import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import _ from "lodash";
import { TailSpin } from "react-loader-spinner";

import Aside from "../../components/Aside/Aside";

interface PaymentHistoryProps { }

const PaymentHistory: React.FC<PaymentHistoryProps> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [errors, setErrors] = React.useState("");
  const [finReport, setFinReport] = React.useState<any>();

  const getHistory = () => {
    setIsLoaded(true);
    try {
      axios.get("v1/stat/finance").then((res) => {
        let grouped_items = _.groupBy(
          res.data.stat.sort((a: any, b: any) =>
            moment(b.actual_date).diff(a.actual_date)
          ),
          (b) => moment.unix(b.actual_date).startOf("month").format("MMMM Y")
        );

        _.values(grouped_items).forEach((arr) =>
          arr.sort((a, b) => moment(b.actual_date).diff(a.actual_date))
        );
        setFinReport(grouped_items);
        setIsLoaded(false);
        setIsOpen(true);
      });
    } catch (err: any) {
      setErrors(err.response.data);

      console.error(err);
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside />
      <main data-v-dde546dc="" className="el-main">
        <div data-v-3563ec52="" data-v-dde546dc="" className="reports-payments">
          <h1 data-v-3563ec52="">История платежей</h1>
          <div
            data-v-3563ec52=""
            className="mt-3 flex justify-between align-center mb-4"
          >
            <div className="flex">
              <p className="fa-md">Загрузить историю</p>
            </div>
            <div className="flex">
              <button
                data-v-3563ec52=""
                type="button"
                className="el-button el-button--primary el-button--small"
                element-loading-text="Загрузка"
                onClick={getHistory}
              >
                <span>
                  <small data-v-3563ec52="">Показать</small>
                </span>
              </button>
            </div>
          </div>
          {isLoaded ? (
            <div data-v-dde546dc="" className="el-main">
              <div
                data-v-dde546dc=""
                className="dashboard justify-center align-center flex"
              >
                <TailSpin color="#d6f1dc" height={100} width={100} />
              </div>
            </div>
          ) : null}
          {isOpen ? (
            <div data-v-3563ec52="" className="loading-container">
              <div data-v-3563ec52="" className="mt-1">
                <div
                  data-v-3563ec52=""
                  className="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"
                >
                  <div className="hidden-columns">
                    <div data-v-3563ec52=""></div>
                    <div data-v-3563ec52=""></div>
                    <div data-v-3563ec52=""></div>
                    <div data-v-3563ec52=""></div>
                    <div data-v-3563ec52=""></div>
                  </div>
                  <div className="el-table__header-wrapper">
                    <table
                      cellSpacing="0"
                      cellPadding="0"
                      className="el-table__header"
                      style={{ width: 1030 }}
                    >
                      <colgroup>
                        <col className="el-table_7_column_23" width="120" />
                        <col className="el-table_7_column_24" width="120" />
                        <col className="el-table_7_column_26" width="100" />
                        <col className="el-table_7_column_27" width="200" />
                        <col className="el-table_7_column_28" width="50" />
                        <col className="gutter" width="0" />
                      </colgroup>
                      <thead className="has-gutter">
                        <tr className="">
                          <th
                            rowSpan={1}
                            colSpan={1}
                            className="el-table_7_column_23 ascending    is-leaf is-sortable"
                          >
                            <div className="cell">Дата платежа</div>
                          </th>
                          <th
                            rowSpan={1}
                            colSpan={1}
                            className="el-table_7_column_24     is-leaf is-sortable"
                          >
                            <div className="cell">Дата внесения</div>
                          </th>

                          <th
                            rowSpan={1}
                            colSpan={1}
                            className="el-table_7_column_26     is-leaf"
                          >
                            <div className="cell">Сумма</div>
                          </th>
                          <th
                            rowSpan={1}
                            colSpan={1}
                            className="el-table_7_column_27  is-right   is-leaf is-sortable"
                          >
                            <div className="cell" style={{ textAlign: "center" }}>Комментарий</div>
                          </th>
                          <th
                            rowSpan={1}
                            colSpan={1}
                            className="el-table_7_column_28  is-right   is-leaf is-sortable"
                          >
                            <div className="cell">Чек</div>
                          </th>
                          <th
                            className="gutter"
                            style={{ width: 0, display: "none" }}
                          ></th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div className="el-table__body-wrapper is-scrolling-none">
                    <table
                      cellSpacing="0"
                      cellPadding="0"
                      className="el-table__body"
                      style={{ width: 1030 }}
                    >
                      <colgroup>
                        <col className="el-table_7_column_23" width="120" />
                        <col className="el-table_7_column_24" width="120" />
                        <col className="el-table_7_column_26" width="100" />
                        <col className="el-table_7_column_27" width="200" />
                        <col className="el-table_7_column_28" width="50" />
                      </colgroup>
                      {Object.keys(finReport).map((key) => (
                        <>
                          <p
                            style={{
                              textAlign: "left",
                              fontSize: "18px",
                              fontWeight: 300,
                              width: "500%",
                              background: "#f4fcf6",
                              borderBottom: "1px solid #d6f1dc;",
                              padding: "5px 10px 10px 10px",
                              color: "#fff",
                              backgroundColor: "#1294a0",
                              borderColor: "#1294a0",
                            }}
                          >
                            <span style={{ textTransform: "capitalize" }}>
                              {key}
                            </span>
                            г.
                          </p>
                          {finReport[key].map((el: any) => (
                            <>
                              <tbody>
                                {el.payment_incurrency.indexOf("+") ? (
                                  <tr
                                    className="el-table__row"
                                    key={el.account_id}
                                    style={{ background: "#f2dbdb" }}
                                  >
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_23  "
                                    >
                                      <div className="cell">
                                        {moment
                                          .unix(el.actual_date)
                                          .format("D MMMM H:mm:ss")}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_24  "
                                    >
                                      <div className="cell">
                                        {moment
                                          .unix(el.actual_date)
                                          .format("D MMMM H:mm:ss")}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_26  "
                                    >
                                      <div className="cell">
                                        {el.payment_incurrency} ₽
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_27 is-right "
                                    >
                                      <div className="cell" style={{ textAlign: "center" }}>
                                        {el.event_name}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_28 is-right "
                                    >
                                      <div className="cell">
                                        -
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr
                                    className="el-table__row"
                                    style={{ background: "#d6f1dc" }}
                                  >
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_23  "
                                    >
                                      <div className="cell">
                                        {moment
                                          .unix(el.actual_date)
                                          .format("D MMMM H:mm:ss")}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_24  "
                                    >
                                      <div className="cell">
                                        {moment
                                          .unix(el.actual_date)
                                          .format("D MMMM H:mm:ss")}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_26  "
                                    >
                                      <div className="cell">
                                        {el.payment_incurrency} ₽
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_27 is-right "
                                    >
                                      <div className="cell" style={{ textAlign: "center" }}>
                                        {el.event_name}
                                      </div>
                                    </td>
                                    <td
                                      rowSpan={1}
                                      colSpan={1}
                                      className="el-table_7_column_28 is-right "
                                    >
                                      <div className="cell">
                                        -
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </>
                          ))}
                        </>
                      ))}
                    </table>
                  </div>
                  <h1>{errors}</h1>
                  <div
                    className="el-table__column-resize-proxy"
                    style={{ display: "none" }}
                  ></div>
                </div>
              </div>
              <div className="el-loading-mask" style={{ display: "none" }}>
                <div className="el-loading-spinner">
                  <svg viewBox="25 25 50 50" className="circular">
                    <circle
                      cx="50"
                      cy="50"
                      r="20"
                      fill="none"
                      className="path"
                    ></circle>
                  </svg>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
};

export default PaymentHistory;
